export default "__VITE_ASSET__CNiAciub__";